import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import qs from 'qs';
import {STATUS} from '@jobseeker/common-core/constants';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}`
);

const getRecommendations = async (status?: number, email?: string) => {
  try {
    const response = await axios.get(`/recommendation/recommendationlist/`, {
      params: {
        status,
        email,
      },
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const resendMail = async (
  email: string,
  recommendationId: number,
  userName: string,
  userEmail: string
) => {
  try {
    const response = await axios.post(
      `/recommendation/resendmail`,
      qs.stringify({
        email,
        recommendationId,
        userName,
        userEmail,
      })
    );

    if (response[STATUS] === 200) {
      return response.data.message;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const sendRecommendationRequest = async (email: string, action: string) => {
  try {
    const response = await axios.post(
      `/recommendation/processrecommendation`,
      qs.stringify({
        email,
        action,
      })
    );
    if (response[STATUS] === 200) {
      return response.data.message;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const approveRecommendation = async (
  recommendationId: number,
  action: string
) => {
  try {
    const response = await axios.post(
      `/recommendation/processrecommendation`,
      qs.stringify({
        recommendationId,
        action,
      })
    );
    if (response[STATUS] === 200) {
      return response.data.message;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const rejectRecommendation = async (
  recommendationId: number,
  action: string
) => {
  try {
    const response = await axios.post(
      `/recommendation/processrecommendation`,
      qs.stringify({
        recommendationId,
        action,
      })
    );
    if (response[STATUS] === 200) {
      return response.data.message;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const recommendationService = {
  getRecommendations,
  resendMail,
  sendRecommendationRequest,
  approveRecommendation,
  rejectRecommendation,
};

export default recommendationService;
